import React from 'react';
import './harbour.css';

/*
 * Harbour/Pathway mark: green circle = SEN pathway, blue square = referral
 * pathway. Decorative — it always sits next to the written pathway name.
 */
export default function HarbourPathwayMark({ pathway, className = '' }) {
  if (pathway !== 'sen' && pathway !== 'referral') return null;
  return <span className={`harbour-pathway-mark harbour-pathway-mark--${pathway} ${className}`.trim()} aria-hidden="true" />;
}
